/**
 * Created by klerick on 26.12.16.
 */
'use strict';
angular.module('webtrader').directive('customPlaceHolder', function($timeout, OpenListOptions, OpenListMarket){
    return {
        restrict: 'A',
        require: '?ngModel',
        scope: {
            openListOptions: '&'
        },
        link: link,
    };

    function link(scope, element, attrs, ngModel){

        let getViewValue = (value) => {
            let textResult = attrs.customPlaceHolder.replace('%value%', value);
            textResult = textResult.replace('%text%', attrs.customPlaceHolderText);
            return textResult;
        };

        ngModel.$formatters.push(getViewValue);
        ngModel.$parsers.push((value) => {
            value+='';
            let result = value.match(/(\d+(\.\d+)?)/g);
            let t;
            if (result) {
                t = result[0];
                if (attrs.maxLength && (t.length > attrs.maxLength)) {
                    t = t.substr(0, attrs.maxLength);
                };
                t = parseFloat(t);
            };
            if (t) {
                return t;
            } else {
                return 1;
            };
        });

        element.bind('focus', (event) => {
            $timeout(() => {
                ngModel.$setViewValue(ngModel.$modelValue);
                ngModel.$render();
            })
        });

        element.on('click', (event) => {
            OpenListMarket.close();
            event.stopPropagation();
            if (OpenListOptions.isOpen) {
               OpenListOptions.close();
            }
            $timeout(() => {
                scope.openListOptions({formatFunction: getViewValue});
            });
        });

        element.on('keydown', (event) => {
            // Allow: backspace, delete, tab, escape, enter
            if ($.inArray(event.keyCode, [46, 8, 9, 27, 13, 110]) !== -1 ||
                 // Allow: Ctrl+A, Command+A
                (event.keyCode === 65 && (event.ctrlKey === true || event.metaKey === true)) || 
                 // Allow: home, end, left, right, down, up
                (event.keyCode >= 35 && event.keyCode <= 40)) {
                    return;
            };
            // Ensure that it is a number and stop the keypress
            if ((event.shiftKey || (event.keyCode < 48 || event.keyCode > 57)) && (event.keyCode < 96 || event.keyCode > 105)) {
                event.preventDefault();
            };
        });

        element.bind('blur', () => {
            $timeout(() => {
                ngModel.$setViewValue(getViewValue(ngModel.$modelValue));
                ngModel.$render();
            });
        });


    }
});
